<template>
  <ul class="icon-text-list">
    <fn-icon-text-list-item
      v-for="(item, index) in items"
      :key="index"
      :icon="item.icon"
      :text="item.text"
      :title="item.title"
    />
  </ul>
</template>

<script setup lang="ts">
import type { IconTextListItemProps } from './IconTextListItem';

type IconTextListProps = {
  items: Array<IconTextListItemProps>;
};

withDefaults(defineProps<IconTextListProps>(), {
  items: () => [],
});
</script>

<style lang="scss" scoped>
.icon-text-list {
  display: flex;
  flex-flow: column;
  padding: 0;
}
</style>
